import React, { useRef, useEffect, useState } from 'react';

export default function TableHeader({ selectedAll, onSelectAll , setSearchCol }) {
  const [columnWidths, setColumnWidths] = useState({});
  const tableRef = useRef(null);

  const columns =[
    { key: 'ts', label: 'Ts' },
    { key: 'AppName', label: 'App Name' },
    { key: 'Environment', label: 'Environment' },
    { key: 'Tenant', label: 'Tenant' },
    { key: 'Endpoint', label: 'Endpoint' },
    { key: 'DurationMs', label: 'Duration Ms' },
    { key: 'CallerIP', label: 'Caller IP' },
    { key: 'Identifier', label: 'Identifier' },
    { key: 'APICallID', label: 'Api Call ID' },
    { key: 'Headers', label: 'Headers' },
    { key: 'Body', label: 'Body' },
  ];

  const handleColumnAction = (column, type, value) => {
    const data = { column, type, value };
    setSearchCol(data);
  };

  const handleMouseDown = (e, key) => {
    const startX = e.clientX;
    const startWidth = e.target.parentElement.offsetWidth;

    const onMouseMove = (eMove) => {
      const newWidth = startWidth + (eMove.clientX - startX);
      setColumnWidths((prev) => ({
        ...prev,
        [key]: newWidth
      }));
    };

    const onMouseUp = () => {
      window.removeEventListener('mousemove', onMouseMove);
      window.removeEventListener('mouseup', onMouseUp);
    };

    window.addEventListener('mousemove', onMouseMove);
    window.addEventListener('mouseup', onMouseUp);
  };

  return (
    <thead style={{ background: "#EAEDF8" }} ref={tableRef}>
      <tr>
        <th>
          <input
            type="checkbox"
            checked={selectedAll}
            onChange={(e) => onSelectAll(e.target.checked)}
          />
        </th>
        {columns.map(({ key, label }) => (
          <th
            key={key}
            style={{ position: 'relative', minWidth: columnWidths[key] || 'auto' }}
          >
            <div style={{ display: 'flex', flexDirection: 'column', }}>
              <span style={{ flex: 1 }}>{label}</span>
              <input
                type="text"
                className="search-input"
                placeholder="Search..."
                onChange={(e) =>
                  handleColumnAction(key, 'search', e.target.value)
                }
              />
            </div>
            <div
              onMouseDown={(e) => handleMouseDown(e, key)}
              className='resize-bar'             
            />
          </th>
        ))}
        {/* <th>Actions</th> */}
      </tr>
    </thead>
  );
}
